import type { SVGProps } from 'react';

export type IconName =
  | 'logo' | 'youtube' | 'upload' | 'folder' | 'mic' | 'headphones' | 'play' | 'pause' | 'stop'
  | 'record' | 'skipBack' | 'skipForward' | 'chevronDown' | 'chevronRight' | 'chevronLeft'
  | 'plus' | 'minus' | 'check' | 'close' | 'settings' | 'sliders' | 'mix' | 'wave' | 'clock'
  | 'volume' | 'volumeMute' | 'solo' | 'download' | 'trash' | 'refresh' | 'sparkle' | 'sync'
  | 'metronome' | 'marker' | 'note' | 'export' | 'monitor' | 'help' | 'shield' | 'bolt'
  | 'menu' | 'home' | 'save' | 'cloud' | 'external' | 'alert' | 'info' | 'search' | 'compare'
  | 'loop' | 'keyboard' | 'tune' | 'timer' | 'checkCircle' | 'redo' | 'install' | 'eye'
  | 'volumeUp' | 'undo' | 'star' | 'scissors' | 'playCircle' | 'arrowRight' | 'more' | 'micOff' | 'lock' | 'layers';

const paths: Record<IconName, React.ReactNode> = {
  logo: <><path d="M3 12h3l2.2-6 4.4 12L15 9l2 3h4"/><circle cx="12" cy="12" r="10" opacity=".22"/></>,
  youtube: <><path d="M22 8s-.2-1.5-.8-2.2c-.8-.9-1.7-.9-2.1-1C16.2 4.5 12 4.5 12 4.5h0s-4.2 0-7.1.3c-.4.1-1.3.1-2.1 1C2.2 6.5 2 8 2 8s-.2 1.7-.2 3.3v1.5C1.8 14.4 2 16 2 16s.2 1.5.8 2.2c.8.9 1.8.9 2.3 1 1.7.2 6.9.3 6.9.3s4.2 0 7.1-.3c.4-.1 1.3-.1 2.1-1 .6-.7.8-2.2.8-2.2s.2-1.7.2-3.3v-1.5C22.2 9.7 22 8 22 8Z"/><path d="m10 8.7 5.3 3.3-5.3 3.3V8.7Z" fill="currentColor" stroke="none"/></>,
  upload: <><path d="M12 16V4m0 0L7 9m5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></>,
  folder: <><path d="M3 7a2 2 0 0 1 2-2h5l2 2h7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z"/><path d="M3 10h18"/></>,
  mic: <><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3m-4 0h8"/></>,
  headphones: <><path d="M3 14v-2a9 9 0 0 1 18 0v2"/><rect x="2" y="13" width="5" height="8" rx="2"/><rect x="17" y="13" width="5" height="8" rx="2"/></>,
  play: <path d="m8 5 12 7-12 7V5Z" fill="currentColor" stroke="none"/>,
  pause: <><path d="M8 5h3v14H8zM15 5h3v14h-3z" fill="currentColor" stroke="none"/></>,
  stop: <rect x="6" y="6" width="12" height="12" rx="1" fill="currentColor" stroke="none"/>,
  record: <circle cx="12" cy="12" r="7" fill="currentColor" stroke="none"/>,
  skipBack: <><path d="M5 5v14M19 5 8 12l11 7V5Z"/></>,
  skipForward: <><path d="M19 5v14M5 5l11 7-11 7V5Z"/></>,
  chevronDown: <path d="m6 9 6 6 6-6"/>,
  chevronRight: <path d="m9 18 6-6-6-6"/>,
  chevronLeft: <path d="m15 18-6-6 6-6"/>,
  plus: <><path d="M12 5v14M5 12h14"/></>,
  minus: <path d="M5 12h14"/>,
  check: <path d="m5 12 4 4L19 6"/>,
  close: <><path d="m18 6-12 12M6 6l12 12"/></>,
  settings: <><circle cx="12" cy="12" r="3"/><path d="m19.4 15 .1.1 1.4 1.1-1.4 2.4-1.7-.6a8 8 0 0 1-1.6.9l-.3 1.8h-2.8l-.3-1.8a8 8 0 0 1-1.6-.9l-1.7.6-1.4-2.4 1.4-1.1a7 7 0 0 1 0-1.9L6.2 12l1.4-2.4 1.7.6a8 8 0 0 1 1.6-.9l.3-1.8H14l.3 1.8a8 8 0 0 1 1.6.9l1.7-.6L19 12l-1.4 1.1a7 7 0 0 1-.2 1.9Z" transform="translate(-1 -1) scale(1.08)"/></>,
  sliders: <><path d="M4 21v-7m0-4V3m8 18v-9m0-4V3m8 18v-5m0-4V3M2 14h4m4-6h4m4 8h4"/></>,
  mix: <><path d="M4 21v-7m0-4V3m8 18V9m0-4V3m8 18v-9m0-4V3M2 14h4m4-6h4m4 8h4"/></>,
  wave: <path d="M2 12h2l2-7 4 14 4-14 4 14 2-7h2"/>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></>,
  volume: <><path d="M4 10v4h4l5 4V6l-5 4H4Z"/><path d="M17 9a5 5 0 0 1 0 6M19.5 6.5a9 9 0 0 1 0 11"/></>,
  volumeMute: <><path d="M4 10v4h4l5 4V6l-5 4H4Z"/><path d="m17 9 5 6m0-6-5 6"/></>,
  solo: <><circle cx="12" cy="12" r="9"/><path d="M8 12h8M12 8v8"/></>,
  download: <><path d="M12 3v12m0 0 5-5m-5 5-5-5"/><path d="M4 17v3h16v-3"/></>,
  trash: <><path d="M4 7h16M10 11v6m4-6v6M5 7l1 13h12l1-13M9 7V4h6v3"/></>,
  refresh: <><path d="M20 11a8 8 0 0 0-14.8-3L4 10"/><path d="M4 5v5h5M4 13a8 8 0 0 0 14.8 3L20 14"/><path d="M20 19v-5h-5"/></>,
  sparkle: <><path d="m12 3 1.5 5.5L19 10l-5.5 1.5L12 17l-1.5-5.5L5 10l5.5-1.5L12 3Z"/><path d="m19 15 .7 2.3L22 18l-2.3.7L19 21l-.7-2.3L16 18l2.3-.7L19 15Z"/></>,
  sync: <><path d="M20 7v5h-5M4 17v-5h5"/><path d="M5.6 9A7 7 0 0 1 18 7l2 5M4 12l2 5a7 7 0 0 0 12.4-2"/></>,
  metronome: <><path d="M12 3 4.5 20h15L12 3Z"/><path d="m12 8 4 7M7.5 20l1.3-3"/></>,
  marker: <><path d="M12 22s7-5.2 7-12a7 7 0 1 0-14 0c0 6.8 7 12 7 12Z"/><circle cx="12" cy="10" r="2.5"/></>,
  note: <><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></>,
  export: <><path d="M12 16V4m0 0L7 9m5-5 5 5"/><path d="M4 16v4h16v-4"/></>,
  monitor: <><rect x="3" y="4" width="18" height="13" rx="2"/><path d="M8 21h8m-4-4v4"/></>,
  help: <><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.5 2.5 0 1 1 4.2 1.8c-1.1.9-1.7 1.3-1.7 2.7M12 17h.01"/></>,
  shield: <><path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="m9 12 2 2 4-4"/></>,
  bolt: <path d="m13 2-9 12h7l-1 8 10-13h-7l1-7Z" fill="currentColor" stroke="none"/>,
  menu: <><path d="M4 6h16M4 12h16M4 18h16"/></>,
  home: <><path d="m3 11 9-8 9 8"/><path d="M5 10v10h14V10M9 20v-6h6v6"/></>,
  save: <><path d="M5 3h12l4 4v14H3V3h2Z"/><path d="M7 3v6h10V3M7 21v-8h10v8"/></>,
  cloud: <><path d="M20 16.2A4 4 0 0 0 18 9h-1.3A6 6 0 0 0 5 11.2 4.5 4.5 0 0 0 6 20h12a4 4 0 0 0 2-3.8Z"/></>,
  external: <><path d="M14 3h7v7M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></>,
  alert: <><path d="m12 3 10 18H2L12 3Z"/><path d="M12 9v5m0 3h.01"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v5m0-8h.01"/></>,
  search: <><circle cx="10.5" cy="10.5" r="6.5"/><path d="m16 16 5 5"/></>,
  compare: <><path d="M3 12h18M12 3v18"/><path d="m7 7 5-4 5 4M7 17l5 4 5-4"/></>,
  loop: <><path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/></>,
  keyboard: <><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M6 9h.01M10 9h.01M14 9h.01M18 9h.01M6 13h.01M10 13h.01M14 13h.01M18 13h.01M8 16h8"/></>,
  tune: <><path d="M4 21v-7m0-4V3m8 18V9m0-4V3m8 18v-5m0-4V3"/><path d="M2 14h4m4-6h4m4 8h4"/></>,
  timer: <><circle cx="12" cy="13" r="8"/><path d="M12 9v4l3 2M9 2h6m-3 0v3"/></>,
  checkCircle: <><circle cx="12" cy="12" r="9"/><path d="m8 12 2.5 2.5L16 9"/></>,
  redo: <><path d="M4 7v5h5M20 17v-5h-5"/><path d="M5.5 9a7 7 0 0 1 12-2L20 12M4 12l2.5 5a7 7 0 0 0 12-2"/></>,
  install: <><path d="M12 3v12m0 0 4-4m-4 4-4-4"/><path d="M5 18v3h14v-3"/></>,
  eye: <><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/></>,
  volumeUp: <><path d="M4 10v4h4l5 4V6l-5 4H4Z"/><path d="M16 9a5 5 0 0 1 0 6m2-9a9 9 0 0 1 0 12"/></>,
  undo: <><path d="M9 7 4 12l5 5"/><path d="M4 12h10a6 6 0 0 1 6 6"/></>,
  star: <path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3l-5.6 2.9 1.1-6.2L3 9.6l6.2-.9L12 3Z"/>,
  scissors: <><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="m8.2 8.2 12.6 12.6M14.1 9.9 20 4M8.2 15.8 12 12"/></>,
  playCircle: <><circle cx="12" cy="12" r="9"/><path d="m10 8 6 4-6 4V8Z" fill="currentColor" stroke="none"/></>,
  arrowRight: <><path d="M5 12h14m-6-6 6 6-6 6"/></>,
  more: <><circle cx="5" cy="12" r="1" fill="currentColor"/><circle cx="12" cy="12" r="1" fill="currentColor"/><circle cx="19" cy="12" r="1" fill="currentColor"/></>,
  micOff: <><path d="M9 9v3a3 3 0 0 0 5.2 2M15 9V5a3 3 0 0 0-5.9-.7M5 10v2a7 7 0 0 0 11.8 5.1M19 10v2a7 7 0 0 1-.4 2.3M12 19v3m-4 0h8M3 3l18 18"/></>,
  lock: <><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 1 1 8 0v3m-4 4v3"/></>,
  layers: <><path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 12 9 5 9-5M3 16l9 5 9-5"/></>,
};

export function Icon({ name, size = 20, strokeWidth = 1.8, className, ...props }: SVGProps<SVGSVGElement> & { name: IconName; size?: number; strokeWidth?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
